(function ($) {
	$.fn.replaceClass = function (oldClass, newClass) {
		return this.removeClass(oldClass).addClass(newClass);
	};
}(jQuery));